(function($, undefined) {
	
	'use strict';
	var utils = Fw.component.models().utils;
	var galleryContainer = $('.gallery-grid-ctn');
	var galleryComponentContainerSelector = '.gallery-component-ctn';
	var galleryItemsSelector = ".gallery-item-ctn";
	var sizer = '.gallery-grid-sizer';
	var galleryAllFieldsErrorMsgSelector = '.gallery-settings-error-msg-all-fields';
	var galleryOneFieldErrorMsgSelector = '.gallery-settings-error-msg-one-field';
	var ajaxLoaderSelector = '.my-ajax-loader';
	
	var init = function (page) {
		var currPage = $(page);
		
		/* Masonry initialisation */
		galleryContainer.each(function() {
			var grid = $(this).imagesLoaded(function() {
				grid.masonry({
					itemSelector: galleryItemsSelector,
					columnWidth: sizer,
					percentPosition: true,
					gutter: 7
				});
			});
		});		
		
		/* event listeners */
		$('.gallery-component-add-image-save-btn').click(function() {
			var container = $(this).parent();
			createGalleryImageData(container);
		});
		$('.gallery-component-edit-image-save-btn').click(function() {
			var container = $(this).parent();
			var id = $(this).data('dataId');
			editGalleryImageData(id, container);
		});
		$('.gallery-component-edit-category-save-btn').click(function() {
			var container = $(this).parent();
			var id = $(this).data('dataId');
			editGalleryCategoryData(id, container);
		});
		$('.gallery-component-add-category-link').click(function() {
			$(this).siblings('.gallery-component-new-category-settings-ctn').toggleClass('show');
		});
		$('.gallery-component-category-list-item-edit-btn').click(function() {
			$(this).siblings('.gallery-component-new-category-settings-ctn').toggleClass('show');
		});
		$('.gallery-component-add-category-save-btn').click(function() {
			var container = $(this).parent();
			createGalleryCategoryData(container);
		});
		$('.gallery-item-add-image-btn').click(function() {
			var dataId = $(this).parents('.gallery-item-ctn').data('dataId');
			$('.gallery-item-settings-' + dataId).toggleClass('show');
		});
		$('.gallery-component-category-list-item-delete-btn').click(function() {
			var dataId = $(this).data('id');
			deleteGenDataById(dataId, $(this));
		});
		$('.gallery-item-delete-icon-ctn').click(function(e) {
			var image = $(this);
			if (!image.hasClass('gallery-item-ctn')) {
				image = $(this).parents('.gallery-item-ctn');
			}
			var dataId = image.data('dataId');
			deleteGenDataById(dataId, image);
		});
		$('.gallery-folder-name-save-btn').click(function() {
			var localId = $(this).parents(galleryComponentContainerSelector).data('localId');
			var value = $('.gallery-folder-name-input:checked').val();
			utils.updateLabelLangs("gallery-component-folder-name-" + localId, value, "en,fr");
		});
		
		//Show or hide gallery header
		$('.gallery-toggle-header-btn-ctn p').click(function() {
			$(this).parent().toggleClass('show');
			$('.gallery-header-ctn').toggleClass('show');
			var labelId = $(this).parents(galleryComponentContainerSelector).data('localId');
			var value;
			if ($('.gallery-header-ctn').hasClass('show')) {
				value = "show";
			} else {
				value = "hide";
			}
			utils.updateLabelLangs("gallery-component-show-hide-header-" + labelId, value, "en,fr");
		});
		
		//handle selection of categories vs show-all
		$('.gallery-categories-ctn input[type=checkbox]').change(function(e) {
			var container = $(this).parents(galleryComponentContainerSelector);
			handleCategorySelection($(this));
			filterImagesBySelectedCategories(container);
		});
		
		// disable deselection of "show all" checkbox
		$('.gallery-categories-ctn input[type=checkbox]').first().click(function(e) {
			if (!$(this).is(':checked')) {
				e.preventDefault();
			}
		});
		
		// hide toggled elements when clicking on document
		$(document).click(function(e) {
			var target = $(e.target);
			if (!target.is(".gallery-categories-ctn") 
				&& target.parents('.gallery-categories-ctn').length === 0 
				&& !target.is('.gallery-component-add-category-link')
				&& !target.is('.gallery-component-new-category-settings-ctn')
				&& target.parents('.gallery-component-new-category-settings-ctn').length === 0) {				
				if ($('.gallery-component-new-category-settings-ctn').hasClass('show')) {
					$('.gallery-component-new-category-settings-ctn').removeClass('show');
				}
			}
		});
	};
	
	
		
	function filterImagesBySelectedCategories(container) {
		var images = container.find('.gallery-item-ctn');
		var selectedCategoryIds = container.find('.gallery-categories-ctn input[type=checkbox]:checked').map(function() {
			return $(this).attr('id').replace('gallery-component-category-', '');
		}).toArray();
		
		if (selectedCategoryIds[0].indexOf("show-all") != -1) {
			images.each(function() {
				if ($(this).hasClass('hidden')) {
					$(this).removeClass('hidden');
					galleryContainer.masonry();
				}
			});
		} 
		else {
			images.each(function() {
				var imageCategoryId = $(this).data('category').toString();
				var found = false;
				for (var key in selectedCategoryIds) {
					var categoryId = selectedCategoryIds[key];
					if (categoryId === imageCategoryId) {
						found = true;
					}
				}
				if (!found) {
					if (!$(this).hasClass('hidden')) {
						$(this).addClass('hidden');
						galleryContainer.masonry();
					}
				} else {
					if ($(this).hasClass('hidden')) {
						$(this).removeClass('hidden');
						galleryContainer.masonry();
					}
				}
			});
		}
	}
	
	
	function handleCategorySelection(selectedElement) {
		var noCategorySelected = true;
		var container = selectedElement.parents(galleryComponentContainerSelector);
		var index = selectedElement.parent().index();
		// if it's a category and not "show all"
		if (index > 0) {
			container.find('.gallery-categories-ctn input[type=checkbox]').each(function() {
				if ($(this).is(':checked')) {
					noCategorySelected = false;
				}
			});
			container.find('.gallery-categories-ctn input[type=checkbox]').first().prop('checked', noCategorySelected);
		} 
		else {
			//when selecting "show all", deselect all other categories
			if (!selectedElement.is('checked')) {
				container.find('.gallery-categories-ctn input[type=checkbox]').each(function(i) {
					if (i > 0) {
						if ($(this).is(':checked')) {
							$(this).prop('checked', false);
						}
					}
				});
			}
		}
	}
	
	function deleteGenDataById(id, element) {
		$.ajax({
			url: "/action/manageGenData?delete=true&id=" + id + "&ajax=true",
			method: "post",
			success: function(response) {
				console.log(response);
				element.hide();
				galleryContainer.masonry();
			},
			error: function(jqxhr, status, error) {
				console.log("Something went wrong deleting the genData with id " + id + ". " + error);
			}
		});
	}
	
	function editGalleryImageData(id, container) {
		var hasCategory = container.parents(galleryComponentContainerSelector).data('hasCategory');
		var currentlySelectedCategoryId = container.data('categoryId');
		
		var imageFilename = container.find('.gallery-component-filename-receiver').html();
		var backgroundImage;
		if (imageFilename !== "File name" && imageFilename != "Nom du fichier") {
			backgroundImage = imageFilename;
		}
		var category;
		if (hasCategory) {
			category = container.find('select option:selected').val();
		}
		var containerSize = container.find('input[name="size"]:checked').val();
		
		if (backgroundImage || containerSize || ((category && category != currentlySelectedCategoryId)) || (!category) ) {
			container.children(galleryOneFieldErrorMsgSelector).removeClass('show');
			
			var url = "/action/manageGenData";
			url += "?id=" + id;
			if (backgroundImage) {
				url += "&field3=" + encodeURIComponent(backgroundImage);
			}
			if (category) {
				url += "&field4=" + encodeURIComponent(category);
			}
			if (containerSize) {
				url += "&field5=" + encodeURIComponent(containerSize);
			}
			url += "&ajax=true";
			
			$.ajax({
				url: url, 
				method: 'post',
				success: function(response) {
					console.log(response);
					location.reload();
				},
				error: function(jqxhr, error, status) {
					console.log('there was an error saving the data: ' + status + " " + error);
				}
			});
		}
		else {
			container.children(galleryOneFieldErrorMsgSelector).addClass('show');
		}
		
	}
	
	function createGalleryImageData(container) {
		var hasCategory = container.parents(galleryComponentContainerSelector).data('hasCategory');
		var imageFilename = container.find('.gallery-component-filename-receiver').html();
		var backgroundImage;
		if (imageFilename !== "File name" && imageFilename != "Nom du fichier") {
			backgroundImage = imageFilename;
		}
		var category;
		if (hasCategory) {
			category = container.find('select option:selected').val();
		}
		var containerSize = container.find('input[name="size"]:checked').val();
		
		if (backgroundImage && containerSize && ((hasCategory && category) || (!hasCategory))) {
			container.children(galleryAllFieldsErrorMsgSelector).removeClass('show');
			
			var url = "/action/manageGenData";
			url += "?field1=image";
			url += "&field2=" + container.parents(galleryComponentContainerSelector).data('localId');
			url += "&field3=" + encodeURIComponent(backgroundImage);
			if (hasCategory) {
				url += "&field4=" + encodeURIComponent(category);
			}
			url += "&field5=" + encodeURIComponent(containerSize);
			url += "&ajax=true";
			
			$.ajax({
				url: url, 
				method: 'post',
				success: function(response) {
					console.log(response);
					location.reload();
				},
				error: function(jqxhr, error, status) {
					console.log('there was an error saving the data: ' + status + " " + error);
				}
			});
		}
		else {
			container.children(galleryAllFieldsErrorMsgSelector).addClass('show');
		}
	}
	
	function createGalleryCategoryData(container) {
		var categoryNameFr = container.find('input[name="new-category-name-fr"]').val();
		var categoryNameEn = container.find('input[name="new-category-name-en"]').val();
		
		if (categoryNameEn && categoryNameFr) {
			container.siblings(galleryAllFieldsErrorMsgSelector).removeClass('show');
			
			var url = "/action/manageGenData";
			url += "?field1=category";
			url += "&field2=" + container.parents(galleryComponentContainerSelector).data('localId');
			url += "&field3=" + encodeURIComponent(categoryNameFr);
			url += "&field4=" + encodeURIComponent(categoryNameEn);
			url += "&ajax=true";
					
			$.ajax({
				url: url, 
				method: 'post',
				success: function(response) {
					console.log(response);
					location.reload();
				},
				error: function(jqxhr, error, status) {
					console.log('there was an error saving the data: ' + status + " " + error);
				}
			});
		} else {
			container.siblings(galleryAllFieldsErrorMsgSelector).addClass('show');
		}
	}
	
	function editGalleryCategoryData(id, container) {
		var categoryNameFr = container.find('input[name="new-category-name-fr"]').val();
		var categoryNameEn = container.find('input[name="new-category-name-en"]').val();
		
		if (categoryNameEn || categoryNameFr) {
			container.siblings(galleryOneFieldErrorMsgSelector).removeClass('show'); 
			
			var url = "/action/manageGenData";
			url += "?id=" + id;
			if (categoryNameFr) {
				url += "&field3=" + encodeURIComponent(categoryNameFr);
			}
			if (categoryNameEn) {
				url += "&field4=" + encodeURIComponent(categoryNameEn);
			}
			url += "&ajax=true";
					
			$.ajax({
				url: url, 
				method: 'post',
				success: function(response) {
					console.log(response);
					location.reload();
				},
				error: function(jqxhr, error, status) {
					console.log('there was an error saving the data: ' + status + " " + error);
				}
			});
		} else {
			container.siblings(galleryOneFieldErrorMsgSelector).addClass('show'); 
		}
	}
	
	
	var gallery = Fw.modules.export('gallery', {
		init: init
	});
	
})(jQuery);